module.exports = __webpack_public_path__ + "static/media/user.ddd7dcc8.svg";